/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Status_Athlete_FinishedInputs */

const fr_week_session_status_athlete_finished = /** @type {(inputs: Week_Session_Status_Athlete_FinishedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé`)
};

/**

* @param {Week_Session_Status_Athlete_FinishedInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_status_athlete_finished = /** @type {((inputs?: Week_Session_Status_Athlete_FinishedInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Status_Athlete_FinishedInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_status_athlete_finished(inputs)
});